module.exports = __webpack_public_path__ + "img/foot-wechat.2bd97fa7.png";